export default __webpack_public_path__ + "static/media/dashb.8c19b227.png";